
<template>
  <v-app id="searchHefcExact">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Host Invoices</v-card-title>
      <v-simple-table dense>
        <thead>
           <tr>
             <th>To exact</th>
             <th>Number</th>
             <th>Description</th>
             <th>Date / Time</th>
             <th>Host</th>
             <th>Country</th>
             <th>User</th>
           </tr>  
         </thead>
         <tbody>
         <tr>
          <td><v-checkbox v-model="allSelected" dense></v-checkbox></td>
          <td>Select all</td> 
         </tr>   
         </tbody> 
         <tbody v-for="(hefcRecord,i) in searchHefcExact" :key="i">
           <tr>
             <td><v-checkbox v-model="hefcRecord.hefc_toexact" dense @click="checkBoxes()"></v-checkbox></td>
             <td @click="$router.open('/eign/hefc/onHefc/' + hefcRecord.hefc_encrid)">{{hefcRecord.hefc_nr}}</td>
             <td @click="$router.open('/eign/hefc/onHefc/' + hefcRecord.hefc_encrid)">{{hefcRecord.hefc_oms}}</td>             
             <td @click="$router.open('/eign/hefc/onHefc/' + hefcRecord.hefc_encrid)">{{hefcRecord.hefc_dt}}</td>
             <td @click="$router.open('/eign/hefc/onHefc/' + hefcRecord.hefc_encrid)">{{hefcRecord.eign_naam}}</td>
             <td>{{hefcRecord.land_code}}</td>
             <td>{{hefcRecord.gebr_code}}</td>
           </tr>  
         </tbody>
            
       </v-simple-table>
       <v-btn class="primary ma-2" :disabled="!oneChecked" small @click="hefcToExact()">To exact</v-btn>
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Finance" :home="true" type="hefc"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      oneChecked: false,
      searchHefcExact: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/eign/hefc/searchHefcExact.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchHefcExact"
          },
          searchHefcExact: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchHefcExact = res.data.searchHefcExact;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    checkBoxes() {
      this.oneChecked = false;
      for(let i = 0;i < this.searchHefcExact.length; i++ ) {
        if (this.searchHefcExact[i].hefc_toexact == true) this.oneChecked = true;
      }  
      return 0;
    },
    hefcToExact() {
     
        this.$axios
          .post("ares/json/ares/eign/hefc/hefcToExact.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "hefcToExact",
            },
            hefcToExact: {
              searchHefcExact: this.searchHefcExact
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.items = res.data.hefcToExact;
              window.open(this.items.filename,'_blank');
              this.$router.reload('/eign/hefc/searchHefcExact/'); 
              /*
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.hefcToExact.text,
                color: res.data.hefcToExact.color,
              });
              */
            }
          });
      
    }
  },
  computed: {
    allSelected: {
      set(selected) {
        this.searchHefcExact.forEach(function (user) {
          user.hefc_toexact = selected;
        });
        this.oneChecked = false;
        for(let i = 0;i < this.searchHefcExact.length; i++ ) {
          if (this.searchHefcExact[i].hefc_toexact == true) this.oneChecked = true;
        } 
      },
      get() {
        return this.searchHefcExact.every(function(user) {
          return user.hefc_toexact;
        });  
      }
    }
  }
};

</script> 
